import { CiCircleCheck } from "react-icons/ci";
import { IoAlertCircleOutline } from "react-icons/io5";
import { FiAlertTriangle } from "react-icons/fi";
import Button from './Button';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText = 'Cancel',
  variant = 'danger', 
  icon: CustomIcon
}) => {
  if (!isOpen) return null;

  const getIconConfig = () => {
    if (CustomIcon) {
      const configs = {
        danger: {
          bgColor: 'bg-red-100 dark:bg-red-900/30',
          iconColor: 'text-red-600 dark:text-red-400'
        },
        warning: {
          bgColor: 'bg-orange-100 dark:bg-orange-900/30',
          iconColor: 'text-orange-600 dark:text-orange-400'
        },
        success: {
          bgColor: 'bg-green-100 dark:bg-green-900/30',
          iconColor: 'text-green-600 dark:text-green-400'
        }
      };
      const config = configs[variant] || configs.danger;
      return { Icon: CustomIcon, ...config };
    }

    switch (variant) {
      case 'danger':
        return {
          Icon: IoAlertCircleOutline,
          bgColor: 'bg-red-100 dark:bg-red-900/30',
          iconColor: 'text-red-600 dark:text-red-400'
        };
      case 'warning':
        return {
          Icon: FiAlertTriangle,
          bgColor: 'bg-orange-100 dark:bg-orange-900/30',
          iconColor: 'text-orange-600 dark:text-orange-400'
        };
      case 'success':
        return {
          Icon: CiCircleCheck,
          bgColor: 'bg-green-100 dark:bg-green-900/30',
          iconColor: 'text-green-600 dark:text-green-400'
        };
      default:
        return {
          Icon: IoAlertCircleOutline,
          bgColor: 'bg-gray-100 dark:bg-gray-900/30',
          iconColor: 'text-gray-600 dark:text-gray-400'
        };
    }
  };

  const { Icon, bgColor, iconColor } = getIconConfig();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm" 
        onClick={onClose}
      />
      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full p-6 border border-gray-200 dark:border-gray-700">
        <div className="flex items-start gap-4 mb-4">
          <div className={`p-3 rounded-full ${bgColor} flex-shrink-0`}>
            <Icon className={`w-6 h-6 ${iconColor}`} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
              {title}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {variant === 'danger' }
              {variant === 'warning' }
              {variant === 'success'}
            </p>
          </div>
        </div>
        <p className="text-gray-600 dark:text-gray-300 mb-6 ml-[60px]">
          {message}
        </p>
        <div className="flex gap-3">
          <Button
            variant="secondary"
            onClick={onClose}
            className="flex-1"
          >
            {cancelText}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            className="flex-1"
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
